const s = {
  name: "KeyCode",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4,0C2.3,0,1,1.3,1,3v2c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3V3C7,1.3,5.7,0,4,0z M3,3c0-0.5,0.5-1,1-1
			c0.5,0,1,0.5,1,1v2c0,0.5-0.5,1-1,1C3.5,6,3,5.5,3,5V3z"/>
		<path class="st0" d="M5,13c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3v2c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3V13z M8,12c-0.5,0-1,0.5-1,1v2
			c0,0.5,0.5,1,1,1c0.5,0,1-0.5,1-1v-2C9,12.5,8.5,12,8,12z"/>
		<path class="st0" d="M24,10c-1.7,0-3,1.3-3,3v2c0,1.7,1.3,3,3,3s3-1.3,3-3v-2C27,11.3,25.7,10,24,10z M23,13c0-0.5,0.5-1,1-1
			c0.5,0,1,0.5,1,1v2c0,0.5-0.5,1-1,1c-0.5,0-1-0.5-1-1V13z"/>
		<path class="st0" d="M28,22c-0.5,0-1,0.5-1,1v1h-2v-1c0-1.7,1.3-3,3-3s3,1.3,3,3v1h-2v-1C29,22.5,28.5,22,28,22z"/>
		<path class="st0" d="M35,37v-1h-2v1c0,1.7,1.3,3,3,3s3-1.3,3-3v-1h-2v1c0,0.5-0.5,1-1,1S35,37.5,35,37z"/>
		<path class="st0" d="M23,36v1c0,0.5,0.5,1,1,1c0.5,0,1-0.5,1-1v-1h2v1c0,1.7-1.3,3-3,3s-3-1.3-3-3v-1H23z"/>
		<path class="st0" d="M32,10c-1.7,0-3,1.3-3,3v2c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3v-2C35,11.3,33.7,10,32,10z M31,13
			c0-0.5,0.5-1,1-1c0.5,0,1,0.5,1,1v2c0,0.5-0.5,1-1,1c-0.5,0-1-0.5-1-1V13z"/>
		<path class="st0" d="M13,3c0-1.7,1.3-3,3-3s3,1.3,3,3v2c0,1.7-1.3,3-3,3s-3-1.3-3-3V3z M16,2c-0.5,0-1,0.5-1,1v2c0,0.5,0.5,1,1,1
			c0.5,0,1-0.5,1-1V3C17,2.5,16.5,2,16,2z"/>
		<path class="st0" d="M36,0c-1.7,0-3,1.3-3,3v2c0,1.7,1.3,3,3,3s3-1.3,3-3V3C39,1.3,37.7,0,36,0z M35,3c0-0.5,0.5-1,1-1s1,0.5,1,1
			v2c0,0.5-0.5,1-1,1s-1-0.5-1-1V3z"/>
		<path class="st0" d="M25,3c0-1.7,1.3-3,3-3s3,1.3,3,3v2c0,1.7-1.3,3-3,3s-3-1.3-3-3V3z M28,2c-0.5,0-1,0.5-1,1v2c0,0.5,0.5,1,1,1
			c0.5,0,1-0.5,1-1V3C29,2.5,28.5,2,28,2z"/>
		<path class="st0" d="M9,0v8h2V0H9z"/>
		<path class="st0" d="M13,18v-8h2v8H13z"/>
		<path class="st0" d="M37,10v8h2v-8H37z"/>
		<path class="st0" d="M17,18v-8h2v8H17z"/>
		<path class="st0" d="M17,20v4h2v-4H17z"/>
		<path class="st0" d="M17,40v-4h2v4H17z"/>
		<path class="st0" d="M21,20v4h2v-4H21z"/>
		<path class="st0" d="M33,20h2v4h-2V20z"/>
		<path class="st0" d="M39,20h-2v4h2V20z"/>
		<path class="st0" d="M29,40v-4h2v4H29z"/>
		<path class="st0" d="M1,10v8h2v-8H1z"/>
		<path class="st0" d="M21,8V0h2v8H21z"/>
		<path class="st0" d="M4,30c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3s-1.3,3-3,3C5.3,33,4,31.7,4,30z M7,29c-0.5,0-1,0.5-1,1s0.5,1,1,1
			c0.5,0,1-0.5,1-1S7.5,29,7,29z"/>
		<path class="st0" d="M9,21c-5,0-9,4-9,9s4,9,9,9c3.5,0,6.6-2,8.1-5h19.4l3.5-4l-3.5-4H17.1C15.6,23,12.5,21,9,21z M27,32v-2h-2v2
			h-2v-2h-2v2h-2v-2h-2v2h-1.3l-0.3,0.6c-1,2.6-3.6,4.4-6.5,4.4c-3.9,0-7-3.1-7-7s3.1-7,7-7c2.9,0,5.5,1.8,6.5,4.4l0.3,0.6h19.8
			l1.8,2l-1.8,2H35v-2h-2v2h-2v-2h-2v2H27z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as KeyCode
};
